import React, { useState } from 'react';

const CATEGORIES = [
    {
        id: 'ACP Front Elevation',
        name: 'ACP Front Elevation',
        description: 'Aluminum Composite Panel front elevation and cladding photos',
        icon: 'fa-building',
        color: '#f03a02'
    },
    {
        id: 'Facade Glazing',
        name: 'Facade Glazing',
        description: 'Structural glass curtain wall and commercial facade glazing photos',
        icon: 'fa-window-maximize',
        color: '#0284c7'
    },
    {
        id: 'Toughened Glass',
        name: 'Toughened Glass',
        description: 'High-strength safety glass elevation and interior partition photos',
        icon: 'fa-shield',
        color: '#059669'
    }
];

const ProjectsTab = ({ projects, onOpenModal, onDeleteProject, getImageUrl }) => {
    const [activeCategory, setActiveCategory] = useState(null);

    const countByCategory = (catName) => {
        return projects.filter(p => (p.category || '').toLowerCase() === catName.toLowerCase()).length;
    };

    const getCategoryCoverImage = (catName) => {
        const catProjects = projects.filter(p => (p.category || '').toLowerCase() === catName.toLowerCase());
        if (catProjects.length > 0) {
            return getImageUrl(catProjects[0].mainImage || catProjects[0].image);
        }
        return '/images/products/acp_cladding.jpg';
    };

    const filteredProjects = activeCategory
        ? (activeCategory === 'ALL' ? projects : projects.filter(p => (p.category || '').toLowerCase() === activeCategory.toLowerCase()))
        : projects;

    return (
        <div className="admin-tab-content">
            {/* TOP HEADER & FILTER BAR */}
            <div className="admin-card m-b20" style={{ padding: '16px 20px', borderRadius: '12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '15px' }}>
                    <div>
                        <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '800', color: '#0f172a' }}>
                            Projects Gallery Management ({projects.length})
                        </h3>
                        {/* <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#64748b' }}>
                            Organized by 3 project categories: ACP Front Elevation, Facade Glazing, and Toughened Glass.
                        </p> */}
                    </div>

                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <button className="admin-btn admin-btn-primary" onClick={() => onOpenModal('project')}>
                            <i className="fa fa-plus m-r5" /> Bulk Upload Images
                        </button>
                    </div>
                </div>

                {/* CATEGORY NAV TABS */}
                <div style={{ display: 'flex', gap: '8px', marginTop: '16px', borderTop: '1px solid #e2e8f0', paddingTop: '14px', flexWrap: 'wrap' }}>
                    <button
                        onClick={() => setActiveCategory(null)}
                        style={{
                            padding: '8px 16px',
                            borderRadius: '8px',
                            border: '1px solid #cbd5e1',
                            backgroundColor: activeCategory === null ? '#1e293b' : '#ffffff',
                            color: activeCategory === null ? '#ffffff' : '#475569',
                            fontWeight: '700',
                            fontSize: '13px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                    >
                        <i className="fa fa-folder m-r5" /> 3 Category Boxes
                    </button>

                    {CATEGORIES.map(cat => {
                        const count = countByCategory(cat.name);
                        const isSelected = activeCategory === cat.name;
                        return (
                            <button
                                key={cat.id}
                                onClick={() => setActiveCategory(cat.name)}
                                style={{
                                    padding: '8px 16px',
                                    borderRadius: '8px',
                                    border: isSelected ? `2px solid ${cat.color}` : '1px solid #cbd5e1',
                                    backgroundColor: isSelected ? cat.color : '#ffffff',
                                    color: isSelected ? '#ffffff' : '#334155',
                                    fontWeight: '700',
                                    fontSize: '13px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px'
                                }}
                            >
                                <i className={`fa ${cat.icon}`} /> {cat.name} ({count})
                            </button>
                        );
                    })}

                    <button
                        onClick={() => setActiveCategory('ALL')}
                        style={{
                            padding: '8px 16px',
                            borderRadius: '8px',
                            border: '1px solid #cbd5e1',
                            backgroundColor: activeCategory === 'ALL' ? '#0f172a' : '#ffffff',
                            color: activeCategory === 'ALL' ? '#ffffff' : '#475569',
                            fontWeight: '700',
                            fontSize: '13px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                    >
                        <i className="fa fa-th-large m-r5" /> View All ({projects.length})
                    </button>
                </div>
            </div>

            {/* VIEW MODE 1: 3 CATEGORY CARDS / BOXES OVERVIEW (When activeCategory === null) */}
            {activeCategory === null && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '22px' }}>
                    {CATEGORIES.map(cat => {
                        const count = countByCategory(cat.name);
                        const coverImg = getCategoryCoverImage(cat.name);

                        return (
                            <div
                                key={cat.id}
                                onClick={() => setActiveCategory(cat.name)}
                                style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '16px',
                                    overflow: 'hidden',
                                    boxShadow: '0 10px 25px rgba(0,0,0,0.06)',
                                    border: '1px solid #e2e8f0',
                                    cursor: 'pointer',
                                    transition: 'transform 0.25s ease, box-shadow 0.25s ease',
                                    position: 'relative'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-4px)';
                                    e.currentTarget.style.boxShadow = '0 15px 35px rgba(0,0,0,0.12)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.06)';
                                }}
                            >
                                {/* BOX IMAGE HEADER */}
                                <div style={{ height: '200px', position: 'relative', overflow: 'hidden', backgroundColor: '#1e293b' }}>
                                    <img
                                        src={coverImg}
                                        alt={cat.name}
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        onError={(e) => { e.target.onerror = null; e.target.style.opacity = '0.5'; }}
                                    />
                                    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.2) 60%)' }} />

                                    {/* BADGE COUNT */}
                                    <span style={{
                                        position: 'absolute',
                                        top: '14px',
                                        right: '14px',
                                        backgroundColor: cat.color,
                                        color: '#ffffff',
                                        fontSize: '12px',
                                        fontWeight: '800',
                                        padding: '5px 12px',
                                        borderRadius: '20px',
                                        boxShadow: '0 4px 10px rgba(0,0,0,0.3)'
                                    }}>
                                        {count} {count === 1 ? 'Image' : 'Images'}
                                    </span>

                                    <div style={{ position: 'absolute', bottom: '16px', left: '16px', right: '16px', color: '#ffffff' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                                            <i className={`fa ${cat.icon}`} style={{ fontSize: '18px', color: cat.color }} />
                                            <h4 style={{ margin: 0, color: '#ffffff', fontWeight: '800', fontSize: '18px' }}>{cat.name}</h4>
                                        </div>
                                    </div>
                                </div>

                                {/* BOX FOOTER CONTENT */}
                                <div style={{ padding: '18px 20px', backgroundColor: '#ffffff' }}>
                                    <p style={{ margin: '0 0 14px 0', fontSize: '13.5px', color: '#64748b', lineHeight: '1.5' }}>
                                        {cat.description}
                                    </p>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '10px', borderTop: '1px solid #f1f5f9' }}>
                                        <span style={{ fontSize: '13px', fontWeight: '700', color: cat.color }}>
                                            Open Category Folder →
                                        </span>
                                        <button
                                            type="button"
                                            className="admin-btn"
                                            style={{ backgroundColor: `${cat.color}15`, color: cat.color, border: 'none', padding: '6px 14px', fontSize: '12px', fontWeight: '700', borderRadius: '6px' }}
                                        >
                                            View {count} Photos
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            {/* VIEW MODE 2: SPECIFIC CATEGORY FOLDER GALLERY GRID (When activeCategory !== null) */}
            {activeCategory !== null && (
                <div className="admin-card">
                    <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <button
                                onClick={() => setActiveCategory(null)}
                                className="admin-btn admin-btn-secondary"
                                style={{ padding: '6px 12px', fontSize: '13px' }}
                            >
                                ← Back to 3 Category Boxes
                            </button>
                            <h3 style={{ margin: 0 }}>
                                {activeCategory === 'ALL' ? 'All Projects Portfolio' : `${activeCategory} Gallery`} ({filteredProjects.length})
                            </h3>
                        </div>

                        <button className="admin-btn admin-btn-primary" onClick={() => onOpenModal('project')}>
                            <i className="fa fa-plus m-r5" /> Add Images to {activeCategory === 'ALL' ? 'Projects' : activeCategory}
                        </button>
                    </div>

                    <div className="card-body">
                        {filteredProjects.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: '40px 20px', backgroundColor: '#f8fafc', borderRadius: '12px' }}>
                                <i className="fa fa-picture-o" style={{ fontSize: '36px', color: '#cbd5e1', marginBottom: '10px' }} />
                                <h4 style={{ margin: '0 0 6px 0', color: '#334155' }}>No Project Images Found</h4>
                                <p style={{ margin: '0 0 15px 0', color: '#64748b', fontSize: '13.5px' }}>
                                    There are currently no photos in the {activeCategory} category.
                                </p>
                                <button className="admin-btn admin-btn-primary" onClick={() => onOpenModal('project')}>
                                    <i className="fa fa-plus m-r5" /> Upload Images Now
                                </button>
                            </div>
                        ) : (
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '20px' }}>
                                {filteredProjects.map((p, index) => (
                                    <div
                                        key={p.id || index}
                                        style={{
                                            borderRadius: '12px',
                                            overflow: 'hidden',
                                            backgroundColor: '#ffffff',
                                            boxShadow: '0 4px 15px rgba(0,0,0,0.06)',
                                            border: '1px solid #e2e8f0',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}
                                    >
                                        <div style={{ height: '180px', position: 'relative', overflow: 'hidden', backgroundColor: '#f1f5f9' }}>
                                            <img
                                                src={getImageUrl(p.mainImage || p.image)}
                                                alt={p.title || 'Project'}
                                                onError={(e) => { e.target.onerror = null; e.target.style.opacity = '0.6'; }}
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                            />
                                            {p.category && (
                                                <span style={{
                                                    position: 'absolute',
                                                    top: '10px',
                                                    left: '10px',
                                                    backgroundColor: 'rgba(0,0,0,0.75)',
                                                    color: '#ffffff',
                                                    fontSize: '11px',
                                                    fontWeight: '700',
                                                    padding: '3px 8px',
                                                    borderRadius: '6px',
                                                    backdropFilter: 'blur(4px)'
                                                }}>
                                                    {p.category}
                                                </span>
                                            )}
                                        </div>
                                        <div style={{ padding: '12px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#ffffff', borderTop: '1px solid #f1f5f9' }}>
                                            <span style={{ fontSize: '13px', fontWeight: '700', color: '#334155', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '120px' }}>
                                                {p.title || p.category || 'Project Image'}
                                            </span>
                                            <div style={{ display: 'flex', gap: '8px' }}>
                                                <button className="admin-btn-icon btn-edit" onClick={() => onOpenModal('project', p)} title="Edit Project">
                                                    <i className="fa fa-pencil" />
                                                </button>
                                                <button className="admin-btn-icon btn-delete" onClick={() => onDeleteProject(p.id)} title="Delete Project">
                                                    <i className="fa fa-trash" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProjectsTab;
